import { render, staticRenderFns } from "./article-add.vue?vue&type=template&id=7f3e98a9&"
import script from "./article-add.vue?vue&type=script&lang=js&"
export * from "./article-add.vue?vue&type=script&lang=js&"
import style0 from "./article-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports